import { makeAutoObservable, runInAction } from "mobx";
import { BackOfficeUser, LoginResponse } from "../client";
import UserRepository from "../data/repositories/UserRepository";
import SessionStorage from "../data/sessionStorage/SessionStorage";
import User from "../model/User";
import ShipmentViewModel from "./ShipmentViewModel";

export interface IUser {
  id?: number;
  name?: string;
  email?: string;
  territoryId?: string;
  role?: string;
  password?: string;
  token?: string;
}

export default class UsersViewModel {
  static instance: UsersViewModel;

  static getInstance(): UsersViewModel {
    if (UsersViewModel.instance === undefined) {
      UsersViewModel.instance = new UsersViewModel();
    }
    return UsersViewModel.instance;
  }

  constructor() {
    makeAutoObservable(this);
    this.loadLocalStorageUser();
    this.loadUsers();
  }

  currentUser: IUser | undefined = undefined;
  users: IUser[] | undefined = undefined;

  async recoverPass(username: string, cllbck: Function) {
    /*
    var credentials: Credentials = { username: username };
    const recoverApi = ApiClient.getClient(Api.RegisterApi) as RegisterApi;
    return recoverApi.resetPassword(credentials).then((res: any) => {
        console.log(res)
        return res
    }).catch(error => console.log(error))*/
  }

  async doLogin(email: string, password: string, cllbck: Function) {
    /* TODO Refactor this. standard api call returns with cors problems. Switched to below snippet. Technical debt to refactor.*/
    UserRepository.doLogin(email, password)
      .then((res: LoginResponse) => {
        console.log('Login response:', res);
        SessionStorage.setToken(res.token || "");
        SessionStorage.setLocalStorageUser(res.profile || "", 0, email);
        if (res.token) {
          const newUser = {
            email: email,
            role: res.profile,
            token: res.token,
          };
          runInAction(() => {
            this.currentUser = newUser;
          });
          console.log('CurrentUser set to:', newUser);
        }
        ShipmentViewModel.getInstance().unLoadShipment();
        ShipmentViewModel.getInstance().unloadAdminShipments();
        cllbck(res);
      })
      .catch((err) => {
        console.error('Login error:', err);
        cllbck(err);
      });
  }

  logOut() {
    SessionStorage.setToken("");
    SessionStorage.setLocalStorageUser("", 0, "");
    runInAction(() => this.currentUser = undefined);
    ShipmentViewModel.getInstance().unLoadShipment();
    ShipmentViewModel.getInstance().unloadAdminShipments();
  }

  loadUsers() {
      UserRepository.getUsers()
        .then((res: BackOfficeUser[]) => {
          if (res === undefined) runInAction(() => this.users = undefined);
          else runInAction(() => this.users = res);
        })
        .catch((error) => {
          runInAction(() => this.users = undefined);
        });
  }

  setCurrentUserByEmail(email: string): void {
    this.loadUserByEmail(email)
      .then((res) => {
        if (res === undefined) runInAction(() => this.currentUser = undefined);
        else runInAction(() => this.currentUser = res);
      })
      .catch((error) => {
        runInAction(() => this.currentUser = undefined);
        return error;
      });
  }

  loadUserByEmail(email: string): Promise<BackOfficeUser> {
    return new Promise<BackOfficeUser>((resolve, reject) => {
      return UserRepository.getUser(email)
        .then((res: BackOfficeUser) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    }).catch((e) => {
      return {
        name: "",
        email: "",
        password: "",
        phone: "",
        role: "",
      } as BackOfficeUser;
    });
  }

  loadLocalStorageUser(): boolean {
    var user: User = SessionStorage.getLocalStorageUser();
    console.log('[UsersViewModel] Loading from localStorage:', user);
    
    if (user.email && user.token) {
      const newUser: IUser = {
        email: user.email,
        role: user.profile,
        token: user.token
      };
      runInAction(() => {
        this.currentUser = newUser;
      });
      console.log('[UsersViewModel] User loaded successfully:', newUser);
      return true;
    } else {
      console.log('[UsersViewModel] No valid user in localStorage');
      return false;
    }
  }

  getUsernameByEmail(email: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.loadUserByEmail(email)
        .then((res) => resolve(res.name || ""))
        .catch((err) => reject(err));
    });
  }
}
